import { Behavior } from "../../base/Behavior";
import { TableRowToolsCell } from "./TableRowToolsCell";
import { Button } from "../button/Button";
import { TableRowMode } from "./TableRowMode";
import { ButtonProps } from "../button/ButtonProps";
import { TableRowToolsViewer } from "./TableRowToolsViewer";
import { Component } from "../../base/Component";

export class TableRowToolsCellBehavior extends Behavior {
    protected constructor() {
        super();
    }

    manageToolsCellWidth(cell: TableRowToolsCell, cellWidth: number): void {
        cell.fixedWidth = cellWidth;
        cell.table.toolsCellAdded(cellWidth);
    }

    shouldAddDragHandler(cell: TableRowToolsCell): boolean {
        return cell.row.mode !== TableRowMode.SEARCH && cell.table.sequenceField != null;
    }

    shouldAddSlideoutButton(cell: TableRowToolsCell): boolean {
        return cell.row.allowEdit === true && cell.table.editLayout != null;
    }

    shouldAddDeleteButton(cell: TableRowToolsCell): boolean {
        return cell.row.mode !== TableRowMode.SEARCH && cell.row.allowDelete;
    }

    get deleteButtonProps(): Partial<ButtonProps> {
        return { themeKey: "tableRow.deleteButton", rowBreak: false, focusable: true }
    }

    setupToolCellPanel(
        cell: TableRowToolsCell, ellipsisButton: Button, viewer: TableRowToolsViewer, tools: Component[]
    ): void {
        cell.toolsPanel.add(ellipsisButton);
    }

    get type(): string {
        return "TableRowToolsCell";
    }
}

TableRowToolsCellBehavior.register();
